<div class="card-item">
  <div class="content-static">
    <a target="_blank" [href]="link">
      <img class="card-img" [src]="image" />
    </a>
  </div>
  <div class="content-superposition">
    <a target="_blank" [href]="link">
      <h1 class="card-header">{{ title }}</h1>
      <p class="card-text">
        {{ category }} | 3 min. de lecture
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </p>
    </a>
  </div>
</div>
